import { ActionIconButton } from '@redislabsdev/redis-ui-components';
import styled from 'styled-components/macro';

export const ActionButton = styled(ActionIconButton)`
  opacity: 0;
  transition: all 0.3s;
`;
